<template>
  <div
    ref="kt_modal_faturamento_editar_nf_produtor"
    data-bs-backdrop="static"
    data-bs-focus="false"
    class="modal fade modal-overlay"
    tabindex="-1"
    id="kt_modal_faturamento_editar_nf_produtor"
    data-bs-keyboard="false"
  >
    <div
      class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable"
    >
      <div class="modal-content">
        <div class="modal-header">
          <div class="card-title d-flex align-items-center">
            <span class="svg-icon svg-icon-1 svg-icon me-3 lh-0">
              <inline-svg src="media/icons/duotune/general/gen005.svg" />
            </span>
            <h3 class="fw-bold m-0 text-gray-800">Referenciar NF</h3>
          </div>
          <div
            class="btn btn-icon btn-sm btn-active-light-primary"
            @click="cancelar()"
          >
            <span class="svg-icon svg-icon-1 svg-icon lh-0">
              <inline-svg src="media/icons/duotune/arrows/arr061.svg" />
            </span>
          </div>
        </div>
        <div class="modal-body p-5">
          <div class="row">
            <div
              class="col-sm-12 col-md-12 col-lg-12 col-xl-6 col-xxl-4 fv-row mb-6"
            >
              <label class="form-label">Nº do Documento Fiscal</label>
              <input
                type="text"
                id="txtNNF"
                :class="[
                  'form-control mb-2',
                  errosValidacao['nNF'] ? 'is-invalid' : '',
                ]"
                v-model="this.refNFP.nNF"
                maxlength="9"
              />
              <div class="fv-plugins-message-container invalid-feedback">
                {{ errosValidacao["nNF"] }}
              </div>
            </div>
            <div
              class="col-sm-12 col-md-12 col-lg-12 col-xl-6 col-xxl-3 fv-row mb-6"
            >
              <label class="form-label">Modelo</label>
              <select
                :class="[
                  'form-select',
                  errosValidacao['mod'] ? 'is-invalid' : '',
                ]"
                v-model="this.refNFP.mod"
              >
                <option v-if="this.produtor === true" value="04">
                  04 - NF de Produtor
                </option>
                <option value="01">01 - NF</option>
              </select>
              <div class="fv-plugins-message-container invalid-feedback">
                {{ errosValidacao["mod"] }}
              </div>
            </div>
            <div
              class="col-sm-12 col-md-12 col-lg-12 col-xl-6 col-xxl-2 fv-row mb-6"
            >
              <label class="form-label">Série</label>
              <input
                type="text"
                id="txtSerie"
                :class="[
                  'form-control mb-2',
                  errosValidacao['serie'] ? 'is-invalid' : '',
                ]"
                v-model="this.refNFP.serie"
                maxlength="3"
              />
              <div class="fv-plugins-message-container invalid-feedback">
                {{ errosValidacao["serie"] }}
              </div>
            </div>
            <div
              class="col-sm-12 col-md-12 col-lg-12 col-xl-6 col-xxl-3 fv-row mb-6"
            >
              <label class="form-label">Emissão</label>
              <el-date-picker
                id="dtpDataEmissao"
                v-model="this.refNFP.AAMM"
                type="datetime"
                name="dtpDataEmissao"
                placeholder="Selecione uma data"
                class="w-100"
                format="DD/MM/YYYY"
                size="large"
                @keydown.stop.prevent.enter=""
                :class="{ 'is-invalid': errosValidacao.AAMM }"
              />
              <div class="fv-plugins-message-container invalid-feedback">
                {{ errosValidacao["AAMM"] }}
              </div>
            </div>
          </div>
          <div class="row">
            <div
              class="col-sm-12 col-md-12 col-lg-12 col-xl-6 col-xxl-3 fv-row mb-6"
            >
              <label class="form-label">UF</label>
              <select
                :class="[
                  'form-select',
                  errosValidacao['cUF'] ? 'is-invalid' : '',
                ]"
                v-model="this.refNFP.cUF"
              >
                <option value="12">Acre</option>
                <option value="27">Alagoas</option>
                <option value="16">Amapá</option>
                <option value="13">Amazonas</option>
                <option value="29">Bahia</option>
                <option value="23">Ceara</option>
                <option value="53">Distrito Federal</option>
                <option value="32">Espirito Santo</option>
                <option value="52">Goiás</option>
                <option value="21">Maranhão</option>
                <option value="51">Mato Grosso</option>
                <option value="50">Mato Grosso do Sul</option>
                <option value="31">Minas Gerais</option>
                <option value="15">Para</option>
                <option value="25">Paraíba</option>
                <option value="41">Paraná</option>
                <option value="26">Pernambuco</option>
                <option value="22">Piauí</option>
                <option value="33">Rio de Janeiro</option>
                <option value="24">Rio Grande do Norte</option>
                <option value="43">Rio Grande do Sul</option>
                <option value="11">Rondônia</option>
                <option value="14">Roraima</option>
                <option value="42">Santa Catarina</option>
                <option value="35">São Paulo</option>
                <option value="28">Sergipe</option>
                <option value="17">Tocantins</option>
              </select>
              <div class="fv-plugins-message-container invalid-feedback">
                {{ errosValidacao["cUF"] }}
              </div>
            </div>
            <div
              class="col-sm-12 col-md-12 col-lg-12 col-xl-6 col-xxl-3 fv-row mb-6"
            >
              <label for="txtCNPJ" class="form-label">CNPJ</label>
              <input
                type="text"
                id="txtCNPJ"
                :class="[
                  'form-control mb-2',
                  errosValidacao['CNPJ'] ? 'is-invalid' : '',
                ]"
                v-model="this.refNFP.CNPJ"
                v-mask="['##.###.###/####-##']"
              />
              <div class="fv-plugins-message-container invalid-feedback">
                {{ errosValidacao["CNPJ"] }}
              </div>
            </div>
            <div
              v-if="this.produtor === true"
              class="col-sm-12 col-md-12 col-lg-12 col-xl-6 col-xxl-3 fv-row mb-6"
            >
              <label for="txtCPF" class="form-label">CPF</label>
              <input
                type="text"
                id="txtCPF"
                :class="[
                  'form-control mb-2',
                  errosValidacao['CPF'] ? 'is-invalid' : '',
                ]"
                v-model="this.refNFP.CPF"
                v-mask="['###.###.###-##']"
              />
              <div class="fv-plugins-message-container invalid-feedback">
                {{ errosValidacao["CPF"] }}
              </div>
            </div>
            <div
              v-if="this.produtor === true"
              class="col-sm-12 col-md-12 col-lg-12 col-xl-6 col-xxl-3 fv-row mb-6"
            >
              <label for="txtIE" class="form-label">IE</label>
              <div class="input-group mb-2">
                <input
                  type="text"
                  id="txtIE"
                  :class="[
                    'form-control',
                    errosValidacao['IE'] ? 'is-invalid' : '',
                  ]"
                  v-model="this.refNFP.IE"
                  maxlength="14"
                />
                <div
                  class="input-group-text form-check form-check-custom form-check-sm"
                >
                  <input
                    class="form-check-input ms-2"
                    type="checkbox"
                    v-model="this.refNFP.isentoIE"
                    tabindex="-1"
                    data-bs-toggle="tooltip"
                    data-bs-dismiss="click"
                    title="Isento"
                    tooltip="Isento"
                    @change="verificarIsentoIE()"
                  />
                </div>
              </div>

              <div class="fv-plugins-message-container invalid-feedback">
                {{ errosValidacao["IE"] }}
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer d-flex justify-content-end">
          <button
            class="btn btn-danger svg-icon-white me-2 mb-2"
            @click="cancelar()"
          >
            <span class="svg-icon svg-icon-1">
              <inline-svg
                src="media/icons/duotune/arrows/arr015.svg"
                class="me-2"
              />Cancelar
            </span>
          </button>
          <button
            class="btn btn-success svg-icon-white mb-2"
            @click="confirmar()"
            v-bind:data-kt-indicator="this.loading ? 'on' : 'off'"
          >
            <span class="indicator-progress">
              <span
                class="spinner-border spinner-border-sm align-middle ms-1"
              ></span>
              Aguarde...
            </span>
            <span class="svg-icon svg-icon-1" v-if="!this.loading">
              <inline-svg
                src="media/icons/duotune/arrows/arr016.svg"
                class="me-2"
              />Confirmar
            </span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { hideModal } from "@/core/helpers/dom";
import Swal from "sweetalert2/dist/sweetalert2.min.js";

export default {
  emits: [
    "exibirModalEditarNFProdutorRural",
    "adicionarNFProdutor",
    "editarNFProdutor",
  ],
  props: {
    index: { type: Number, required: true, default: -1 },
    refNFPFaturamento: { type: Object, required: true },
    produtor: { type: Boolean, required: true, default: true },
  },
  methods: {
    async confirmar() {
      this.errosValidacao = {};
      this.loading = true;

      if (this.validar() === true) {
        if (this.index === -1) {
          this.$emit("adicionarNFProdutor", this.refNFP);
        } else {
          this.$emit("editarNFProdutor", this.refNFP, this.index);
        }
        hideModal(this.$refs.kt_modal_faturamento_editar_nf_produtor);
        this.$emit("exibirModalEditarNFProdutorRural", false);
      } else {
        await this.$swal.showInvalidAlert("Verifique os avisos!");
      }

      this.loading = false;
    },
    validar() {
      let result = true;

      if (!this.refNFP.nNF) {
        this.errosValidacao.nNF = "O Nº do documento é inválido";
        result = false;
      } else if (this.refNFP.nNF.trim().length <= 0) {
        this.errosValidacao.nNF = "O Nº do documento é inválido";
        result = false;
      }

      if (!this.refNFP.mod) {
        this.errosValidacao.mod = "O Modelo não foi selecionado";
        result = false;
      } else if (this.refNFP.mod.trim().length <= 0) {
        this.errosValidacao.mod = "O Modelo não foi selecionado";
        result = false;
      }

      if (!this.refNFP.serie) {
        this.errosValidacao.serie = "Informe a série do documento";
        result = false;
      } else if (this.refNFP.serie.trim().length <= 0) {
        this.errosValidacao.serie = "Informe a série do documento";
        result = false;
      }

      if (!this.refNFP.cUF) {
        this.errosValidacao.cUF = "Informe a UF";
        result = false;
      } else if (this.refNFP.cUF.trim().length <= 0) {
        this.errosValidacao.cUF = "Informe a UF";
        result = false;
      }

      if (!this.refNFP.CNPJ && !this.refNFP.CPF) {
        this.errosValidacao.CNPJ = "Informe o CNPJ ou CPF";
        this.errosValidacao.CPF = "Informe o CNPJ ou CPF";
        result = false;
      } else if (
        this.refNFP.CNPJ &&
        this.refNFP.CNPJ.trim().length > 0 &&
        !this.$utils.validarCPFCNPJ(this.refNFP.CNPJ)
      ) {
        this.errosValidacao.CNPJ = "O CNPJ informado é inválido";
        result = false;
      } else if (
        this.refNFP.CPF &&
        this.refNFP.CPF.trim().length > 0 &&
        !this.$utils.validarCPFCNPJ(this.refNFP.CPF)
      ) {
        this.errosValidacao.CPF = "O CPF informado é inválido";
        result = false;
      }

      if (!this.refNFP.AAMM) {
        this.errosValidacao.AAMM = "A data de emissão não foi informada";
        result = false;
      }

      return result;
    },
    cancelar() {
      hideModal(this.$refs.kt_modal_faturamento_editar_nf_produtor);
      this.$emit("exibirModalEditarNFProdutorRural", false);
    },
    nextFocus(id) {
      if (document.getElementById(id) != null) {
        document.getElementById(id).focus();
      }
    },
    verificarIsentoIE() {
      if (this.refNFP.isentoIE) {
        if (this.refNFP.isentoIE === true) {
          this.refNFP.IE = "ISENTO";
        } else {
          this.refNFP.IE = "";
        }
      } else {
        this.refNFP.IE = "";
      }
    },
  },
  mounted() {
    if (this.index >= 0) {
      this.refNFP = JSON.parse(JSON.stringify(this.refNFPFaturamento));
    } else {
      this.refNFP = {};
    }
    this.errosValidacao = {};
    this.$utils.requestFocus("txtNNF");
  },
  data() {
    return {
      errosValidacao: [],
      loading: false,
      refNFP: "",
    };
  },
};
</script>

<style></style>
